export default {
  getSearchStateFromUrl(query) {
    let state = {};
    if (
      query.destinationId &&
      Number.isInteger(parseInt(query.destinationId))
    ) {
      state.destinationId = query.destinationId;
      state.destinationDisplay = true;
    } else {
      state.destinationId = NaN;
      state.destinationDisplay = false;
    }
    return state;
  }
};
